import { siteId } from "Selectors/DashboardSelector"

const create = (api) => {
  const getBatteriesToReplaceSoonCard = (
    startDate = undefined,
    endDate = undefined,
    siteId = undefined,
    countAbove = 500,
    cycleCount = 300,
    agingMonths = 24,
    agingMonthsTop = 30,
    batteryPercentage = 75,
    bottomBatteryPercentage = 50,
  ) => {
    return api.get(`/dashboard/batteryhealth/dashboardcombinedcount/${siteId}?startDate=${startDate}&endDate=${endDate}&cycleCountTop=${countAbove}&cycleCount=${cycleCount}&agingMonths=${agingMonths}&agingMonthsTop=${agingMonthsTop}&batteryPercentage=${batteryPercentage}&bottomBatteryPercentage=${bottomBatteryPercentage}`)
  }

  const getBatteriesToReplaceSoonDetails = (
    startDate = undefined,
    endDate = undefined,
    siteId = undefined,
    params = {},
    pageNumber = 1,
    pageSize = 100,
    countAbove = 500,
    cycleCount = 300,
    agingMonths = 24,
    agingMonthsTop = 30,
    batteryPercentage = 75,
    bottomBatteryPercentage = 50,
  ) => {
    const query = (params.searchTerm === null || params.searchTerm === undefined) ? `&query=` : `&query=${params.searchTerm}`
    const sort = (params.sort === null || params.sort === undefined) ? `&sort=` : `&sort=${params.sort}`
    const directionSort = (params.directionSort === null || params.directionSort === undefined) ? `&directionSort=` : `&directionSort=${params.directionSort}`
    const language = (params.language === null || params.language === undefined) ? `&language=en-US` : `&language=${params.language}`
    const includeChildren = true
    return api.get(`/dashboard/batteryhealth/combined/details/${siteId}?startDate=${startDate}&endDate=${endDate}&cycleCountTop=${countAbove}&cycleCount=${cycleCount}&agingMonths=${agingMonths}&agingMonthsTop=${agingMonthsTop}&batteryPercentage=${batteryPercentage}&bottomBatteryPercentage=${bottomBatteryPercentage}&includeChildren=${includeChildren}&pageNumber=${pageNumber}&pageSize=${pageSize}` + `${query}` + `${sort}${directionSort}${language}`)
  }

 const getExportBatteriesToReplaceSoonCVSFile = (
   siteId = undefined,
   startDate = undefined,
   endDate = undefined,
   params = {},
   pageNumber = 1,
   pageSize = 100,
   payload = null,
   countAbove = 500,
   cycleCount = 300,
   agingMonths = 24,
   agingMonthsTop = 30,
   batteryPercentage = 75,
   bottomBatteryPercentage = 50,
  ) =>
   {
    const query = (params.query === null || params.query === undefined) ? `&query=` : `&query=${params.query}`
    const sort = (params.sort === null || params.sort === undefined) ? `&sort=` : `&sort=${params.sort}`
    const directionSort = (params.directionSort === null || params.directionSort === undefined) ? `&directionSort=` : `&directionSort=${params.directionSort}`
    const language = (params.language === null || params.language === undefined) ? `&language=en-US` : `&language=${params.language}`
    const includeChildren = true
    const chartName = params?.chartName || 'BATTERIES_REPLACE_SOON'
   return api.post(`/dashboard/exportfiles/${siteId}?startDate=${startDate}&endDate=${endDate}&chartName=${chartName}&cycleCountTop=${countAbove}&cycleCount=${cycleCount}&agingMonths=${agingMonths}&agingMonthsTop=${agingMonthsTop}&batteryPercentage=${batteryPercentage}&minimumBatteryPercentage=${bottomBatteryPercentage}&includeChildren=${includeChildren}&pageNumber=${pageNumber}&pageSize=${pageSize}&exportWithPagingSorting=true` + `${query}` + `${sort}${directionSort}${language}`, payload);
   }



  return {
    getBatteriesToReplaceSoonCard,
    getBatteriesToReplaceSoonDetails,
    getExportBatteriesToReplaceSoonCVSFile
  }
}

export default {
  create
}

